module.exports = __webpack_public_path__ + "fe514431ce7922c28d2d322faa28b7f6.svg";